module.exports = __webpack_public_path__ + "img/distribuidores.20528e4d.png";